<template>
  <v-footer height="60" elevation="15" class="app-footer">
    <div class="flex-grow-1"></div>
    <div>Copyright &copy; 2026 Nobuaki Honda All Rights Reserved.</div>
  </v-footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style lang="scss" scoped>
@use "../assets/sass/variables" as v;
.app-footer {
  background-color: v.$footer-color !important;
}

.v-footer div {
  font-family: v.$title-font;
  font-size: 1.2rem;
  letter-spacing: 0.03em;
  color: white;
}
</style>
